var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"AliyunCaptcha"},[_c('div',{attrs:{"id":"captcha-element"}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"id":"captcha-button"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }